export const INTERNET_PRODUCT = 'internet';
export const SUB_PRODUCT_NAME = 'FNOL';

export enum SegmentEventNameTypes {
    VIEW = 'view',
    ACTION = 'action',
    EXCEPTION = 'exception',
}
